import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { ProjectDocstoreView } from "./ui/project-docstore-view";

export const createProjectDocstoreView = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.project.docstore()}`,
    element: createElement(ProjectDocstoreView),
    children: [...rest],
  };
};
